/* Shared focus-visible ring — brand orange, legible on both light and dark
   sections. Every interactive element is a real <button> or <a> now, so the
   `keyActivate` helper that made `div role="button"` operable by keyboard has
   nothing left to patch up. */
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#CB4909]";
